// extracted by mini-css-extract-plugin
export default {"generalContent":"ApresentacaoSobre_generalContent__cfqtg"};